import { array, number, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ProductData, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentService } from './useCurrentService';

const orderByProductOrdering = pipe(
    number.Ord,
    ord.contramap(({ ordering }: ProductData) => ordering)
);

const orderByProductNameOrdering = pipe(
    string.Ord,
    ord.contramap(({ name }: ProductData) => name)
);

export const useProductsOverviewEntries = () => {
    const { id } = useCurrentService();
    return useRepositorySuspenseQuery(
        'products',
        'getOverviewEntries',
        {
            serviceId: id,
        },
        {
            select: ({ productTableData }) => {
                if (array.isEmpty(productTableData)) {
                    return [];
                }
                return pipe(
                    productTableData,
                    array.map((data) => ({
                        ...data,
                        data: pipe(data.data, array.sortBy([orderByProductOrdering, orderByProductNameOrdering])),
                    }))
                );
            },
            refetchOnMount: 'always',
        }
    );
};
